function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import PropTypes from 'prop-types';
import formatcoords from 'formatcoords';
import { Translate } from "../../I18N";

import { Map } from "../../Map";

const GeolocationViewer = ({ points, onlyForCards }) => {
  if (onlyForCards) {
    return (/*#__PURE__*/
      _jsx("div", {}, void 0,
      points.
      filter((p) => Boolean(p)).
      map((p, i) => {
        const coords = formatcoords(p.lat, p.lon);
        return (/*#__PURE__*/
          _jsx("div", {}, i,
          p.label ? `${p.label}: ` : '',
          coords.format('DD MM ss X', { latLonSeparator: ', ', decimalPlaces: 0 })
          ));

      })
      ));

  }

  const markers = [];
  points.
  filter((p) => Boolean(p)).
  forEach(({ lat, lon, label, color }) => {
    markers.push({
      latitude: lat,
      longitude: lon,
      properties: _objectSpread({ info: label }, color ? { color } : {})
    });
  });

  const componentProps = markers.length ?
  { latitude: markers[0].latitude, longitude: markers[0].longitude } :
  {};

  return (/*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement(Map, _extends({}, componentProps, { height: 370, markers: markers, mapStyleSwitcher: true, showControls: true })), /*#__PURE__*/
    _jsx("div", { className: "print-view-alt" }, void 0, /*#__PURE__*/
    _jsx("p", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Latitude"), ": ", componentProps.latitude
    ), /*#__PURE__*/
    _jsx("p", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Longitude"), ": ", componentProps.longitude
    )
    )
    ));

};

GeolocationViewer.defaultProps = {
  points: [],
  onlyForCards: true
};






export default GeolocationViewer;